import { useState, useEffect } from "react";
import soharLogo from "@/assets/sohar-logo-hq.webp";

const SplashScreen = () => {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const shown = sessionStorage.getItem("splash_shown");
    if (shown) {
      setVisible(false);
      return;
    }
    sessionStorage.setItem("splash_shown", "1");
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setVisible(false), 700);
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-navy transition-opacity duration-700 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center gap-6 animate-fade-in">
        <img
          src={soharLogo}
          alt="Sohar"
          className="h-20 md:h-28 invert animate-[pulse_2s_cubic-bezier(0.4,0,0.6,1)_1]"
        />
        <div className="flex gap-1.5">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-2 h-2 rounded-full bg-cream/60"
              style={{
                animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
